// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__0vfgF","header":"Sidebar_header__xhhJ4","title":"Sidebar_title__Lx4tw","options":"Sidebar_options__9HdtO","tabs":"Sidebar_tabs__WfGzr"};